import loadable from '@loadable/component';
export const manifest = {
  Link: {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "Link";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "Link" */
          '.'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak(".");
            }

            return eval('require.resolve')(".");
          }

        }, {
          resolveComponent: mod => mod.Link
        })
      }
    },
    withCollectorData: true
  },
  LinkPId: {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "LinkPid";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "LinkPid" */
          './link-pid'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./link-pid");
            }

            return eval('require.resolve')("./link-pid");
          }

        }, {
          resolveComponent: mod => mod.LinkPid
        })
      }
    }
  },
  LinkWithOffset: {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "LinkWithOffset";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "LinkWithOffset" */
          '.'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak(".");
            }

            return eval('require.resolve')(".");
          }

        }, {
          resolveComponent: mod => mod.Link
        }),
        defaultProps: {
          scrollOffset: -40
        }
      }
    }
  }
};